import CocktailN1 from "../images/Cocktailn1.webp";
import CocktailN2 from "../images/Cocktailn2.webp";
import TTMM from "../images/Tasty_Themes_for_Mono_Myths.webp";

export const albums = [
  {
    id: "ttmm",
    title: "Tasty Themes for Mono Myths",
    month: "11",
    year: "2024",
    cover: TTMM,
    links: {
      spotify: "https://open.spotify.com/album/FAKE3",
      apple: "https://music.apple.com/album/FAKE3",
      youtube: "https://youtube.com/playlist?list=FAKE3",
    },
  },
  {
    id: "cocktail-2",
    title: "Cocktail Nº2",
    month: "12",
    year: "2023",
    cover: CocktailN2,
    links: {
      spotify: "https://open.spotify.com/album/FAKE2",
      apple: "https://music.apple.com/album/FAKE2",
      youtube: "https://youtube.com/playlist?list=FAKE2",
    },
  },
  {
    id: "cocktail-1",
    title: "Cocktail Nº1",
    month: "04",
    year: "2023",
    cover: CocktailN1,
    links: {
      spotify: "https://open.spotify.com/album/FAKE1",
      apple: "https://music.apple.com/album/FAKE1",
      youtube: "https://youtube.com/playlist?list=FAKE1",
      deezer: "https://www.deezer.com/album/FAKE1",
      bandcamp: "https://samebloodscocktail.bandcamp.com/album/cocktail-1",
    },
  },
];
